module.exports = __webpack_public_path__ + "img/icon-add-need.04d4eb8c.svg";